import { FC } from 'react'
import styled from 'styled-components'
import Button from '@app.components/Button'
import { TActivityFilterItem } from '@app.feature/activityFilter/store/storeActivityFilter'

interface IFFilterItemProps {
  item: TActivityFilterItem
  onClick: (item: TActivityFilterItem) => void
  isActive?: boolean
  className?: string
}

const FilterItem: FC<IFFilterItemProps> = ({
  item,
  onClick,
  isActive = false,
  className,
}) => {
  const handleClick = () => {
    onClick(item)
  }

  return (
    <StyledWrapper
      onClick={handleClick}
      color={isActive ? 'primary' : 'lightGrey'}
      className={className}
    >
      {item.label}
    </StyledWrapper>
  )
}

export default FilterItem

const StyledWrapper = styled(Button)`
  box-sizing: border-box;
  width: 100%;
  height: 50px;
`
